module.exports = {
    api:{
      //baseURL: "http://localhost:5000"
      // baseURL: "https://proyecto-adminlite-bak.onrender.com/"
         baseURL: "https://proyecto-adminlite-bak-2.onrender.com"
    }
}
